export default "__VITE_ASSET__CurRiuOd__"